import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PagesContext } from '../store/PagesContext';

import purpleCorner from '../assets/images/purple-corner-left-top.png';
import purplePolygon from '../assets/images/svg/purple-polygon.svg';

import Intro from 'routes/decision-trees/components/Intro';

const IsoD = ({ setCurrentPage }) => {
  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage('isoB'), []);

  const nsoTransitionHandler = () => setCurrentPage('nso');

  return (
    <>
      <div className='mw-700 m-auto py-sm-5'>
        <h1 className='page-heading text-center mb-5'>I did not exercise within the 90-day post-termination exercise window (PTE)!</h1>

        <Intro background={purplePolygon} onClick={nsoTransitionHandler}>
          <h2 className='my-5'>
            Let&apos;s get you <br />
            redirected to <br />
            the NSO tree!
          </h2>
          <div>Continue &gt;</div>
        </Intro>
      </div>

      <img src={purpleCorner} className='corner-blue-top' alt='' />
    </>
  );
};

IsoD.propTypes = {
  setCurrentPage: PropTypes.func
};

export default IsoD;
